import _ from 'lodash';
import moment from 'moment';
import Fuse from 'fuse.js';

const config = (context) => ({
    hideListHeader: true,
    editPath: "attachments",
    pageTitle: "Attachments",
    pageIcon: "assignment_ind",
    listQueryId: "searchCaseAttachments",
    responseFieldName: "searchRelations",
    addNewModal: false,
    hideNewRecordButton: true,
    linkRows: false,
    linkConfigs: [
        // {
        //     name: 'name',
        //     hrefCallback: (column, name, item) => {
        //         return '#/attachments/' + item.id;
        //     },
        //     titleCallback: (column, name, item) => {
        //         return item.name;
        //     },
        // },
    ],
    itemActions: [
        {
            class: "md-just-icon md-warning md-simple",
            icon: "edit",
            click: (item) => context.onEdit(item),
            showCallback: () => context.$Session.isAdminGroupMember,
        },
        {
            class: "md-just-icon md-danger md-simple",
            icon: "close",
            click: (item) => context.onRemove(item),
            showCallback: () => context.$Session.isAdminGroupMember,
        },
    ],
    deleteQueryId: "deleteRelation",
    // deleteRelatedRecord: {
    //     record: [
    //         { deleteSyncQueryId: "deleteRelation", relatedModelItem: 'steps' }
    //     ]
    // },
    deleteMessageNameFields: ['description'],
    columns: {
        'esData.attachment.name': { label: "File Name", sortable: false, esNested: true },
        'esData.attachment.description': { label: "Description", sortable: false, esNested: true },
        'esData.attachment.type': { label: "Type", sortable: false, esNested: true },
        'esData.createdAt': { label: "Uploaded", sortable: false, esNested: true },
        'esData.updatedBy': { label: "Owner", sortable: false, display: true, esNested: true, nested: ["given_name", "family_name"]  },
    },
    ignoreSortColumns: [
        'attachmentName',
        'attachmentDescription',
        'attachmentType',
        'createdAt',
        'ownerName',
    ],
    addDefaultSortIfNone: false,
    perPageOptions: [5, 10, 20, 25, 50],
    defaults: {
        sort: "createdAt",
        sortDir: "desc",
        perPage: 10,
        limit: 999,
        customFieldSort: true //to allow dateDue sorting
    },
    fuseSearch: null,
    formatResponse: (data) => {
        let result = [];
        let items = context.$reduce(data, 'searchRelations.items');
        
        const isInternalMember = context.$Session && context.$Session.isInternalGroupMember;
        const internalMemberMessage = 'For Internal Members Only';

        if (items && items.length) {
            // filter items with valid attachment
            // items = items.filter(_item =>
            //     _item.attachment
            //     && _item.attachment.id
            //     && !_item.attachment.isDeleted &&
            //     ((context.$Session && context.$Session.isInternalGroupMember) || !_item.attachment.internal)
            // );

            items.forEach(_item => {
                // fix for deleted attachments as we can't query nested data in elasticsearch
                if (!_item.attachment) {
                    _item.attachment = {
                        attachmentName: 'Deleted Attachment',
                    }
                }

                _item.relateRecordId = _item.id;
                _item.id = _item.attachment.id;

                // add name
                // _item.attachmentName = _item.attachment.name;

                // add description 
                // _item.attachmentDescription = _item.attachment.description;

                // add formatted item type
                if (_item.esData) {
                    let esData = JSON.parse(_item.esData);
                    // _item.attachmentType = _item.attachment.type.toString().replace(/_/ig, ' ');
                    esData.attachment.type = esData.attachment.type.toString().replace(/_/ig, ' ');
                    _item.esData = JSON.stringify(esData);
                }

                // add owner
                // _item.ownerName = '';
                // if (_item.updatedBy && _item.updatedBy.id) {
                //     _item.ownerName = `${_item.updatedBy.given_name} ${_item.updatedBy.family_name}`;
                // }
                
                // if internal attachment and member is not internal then mask
                if (!isInternalMember && _item.attachment.internal) {
                    // _item.attachmentName = internalMemberMessage;
                    // _item.attachmentDescription = '';
                    // _item.attachmentType = '';
                    // _item.createdAt = '';
                    // _item.ownerName = '';
                    if(_item.esData){
                        let esData = JSON.parse(_item.esData);
                        esData.attachment.name = internalMemberMessage;
                        esData.attachment.description = '';
                        esData.attachment.type = '';
                        esData.createdAt = '';
                        esData.updatedBy = '';
                        _item.esData = JSON.stringify(esData);
                    }
                }

                result.push(_item);
            });
        }

        // // apply filtery query 
        // if (context.searchModel.query) {
        //     const fuse = new Fuse(result, {
        //         keys: [
        //             'attachmentName',
        //             'attachmentDescription',
        //             'attachmentType',
        //             'createdAt',
        //             'ownerName'
        //         ],
        //         threshold: 0.1
        //     });
        //     result = fuse.search(context.searchModel.query);
        // }

        // // apply filter type
        // if (context.searchModel.type && result.length) {
        //     result = result.filter(_item => {
        //         const type = context.$reduce(_item, 'attachment.type');
        //         return type === context.searchModel.type;
        //     });
        // }

        // // sort items
        // if (result.length) {
        //     const listRef = context.$refs.attachmentsListRef;
        //     const sortOrder = listRef.currentSortDir;

        //     let sortKey = context.$reduce(this, `list.columns.${listRef.currentSort}.sortKey`);
        //     if (!sortKey) {
        //         sortKey = listRef.currentSort;
        //     }

        //     result = _.sortBy(result, sortKey);
        //     if ('desc' == sortOrder) {
        //         result = result.reverse();
        //     }
        // }

        window.$bus.$emit("badge-changed", 'attachments', result.length)
        window.$bus.$emit("badge-changed", 'service-attachments', result.length)
        
        return result;
    },
});


export default config;
